query AvailableEntityApproverList( $entityApprovalId: UUID!) {
  availableEntityApproverList(entityApprovalId: $entityApprovalId,
    orderBy: NAME_ASC) {
    nodes {
      user {
        name
      }
      id
    }
  }
}